/* eslint-disable no-param-reassign */
/* eslint-disable import/prefer-default-export */
export class AhorrosMockProvider {
  static activo = true as boolean;

  pojos = [
    {
      mes: 202104,
      anio: 2021,
      ahorroTotal: -8.0,
      ahorroPotencialOro: 0.0,
      ahorroPertenenciaClub: -1.25,
      ahorroTarjetaEroski: -0.25,
      ahorroPertenenciaPlan: -0.25,
      ahorroOfertasSocio: -0.25,
      ahorroVales: -0.25,
      ahorroComprasOnlineOtrasEmpresas: -0.25,
      ahorroTarjetaOro: -0.25,
      ahorroEmpresasBonificadas: -0.25,
      ahorroOtros: 0.5,
      ahorroOfertaMasiva: -2.75,
      ahorroPuntosTravel: -4.0,
      porcentSocio: 16,
      porcentOfertas: 34,
      porcentPuntosTravel: 50,
    },
    {
      mes: 202103,
      anio: 2021,
      ahorroTotal: 0.0,
      ahorroPotencialOro: 0.0,
      ahorroPertenenciaClub: 0.0,
      ahorroTarjetaEroski: 0.0,
      ahorroPertenenciaPlan: 0.0,
      ahorroOfertasSocio: 0.0,
      ahorroVales: 0.0,
      ahorroComprasOnlineOtrasEmpresas: 0.0,
      ahorroTarjetaOro: 0.0,
      ahorroEmpresasBonificadas: 0.0,
      ahorroOtros: 0.0,
      ahorroOfertaMasiva: 0.0,
      ahorroPuntosTravel: 0.0,
      porcentSocio: 0,
      porcentOfertas: 0,
      porcentPuntosTravel: 0,
    },
    {
      mes: 202102,
      anio: 2021,
      ahorroTotal: 5.25,
      ahorroPotencialOro: 0.0,
      ahorroPertenenciaClub: -1.25,
      ahorroTarjetaEroski: -1.75,
      ahorroPertenenciaPlan: -2.0,
      ahorroOfertasSocio: 1.0,
      ahorroVales: 0.5,
      ahorroComprasOnlineOtrasEmpresas: 0.0,
      ahorroTarjetaOro: 0.0,
      ahorroEmpresasBonificadas: 0.5,
      ahorroOtros: 0.5,
      ahorroOfertaMasiva: 2.5,
      ahorroPuntosTravel: 4.0,
      porcentSocio: -24,
      porcentOfertas: 48,
      porcentPuntosTravel: 76,
    },
    {
      mes: 202101,
      anio: 2021,
      ahorroTotal: 0.0,
      ahorroPotencialOro: 0.0,
      ahorroPertenenciaClub: 0.0,
      ahorroTarjetaEroski: 0.0,
      ahorroPertenenciaPlan: 0.0,
      ahorroOfertasSocio: 0.0,
      ahorroVales: 0.0,
      ahorroComprasOnlineOtrasEmpresas: 0.0,
      ahorroTarjetaOro: 0.0,
      ahorroEmpresasBonificadas: 0.0,
      ahorroOtros: 0.0,
      ahorroOfertaMasiva: 0.0,
      ahorroPuntosTravel: 0.0,
      porcentSocio: 0,
      porcentOfertas: 0,
      porcentPuntosTravel: 0,
    },
    {
      mes: 202012,
      anio: 2020,
      ahorroTotal: 1.0,
      ahorroPotencialOro: 0.0,
      ahorroPertenenciaClub: 0.0,
      ahorroTarjetaEroski: 0.0,
      ahorroPertenenciaPlan: 0.0,
      ahorroOfertasSocio: 0.0,
      ahorroVales: 0.0,
      ahorroComprasOnlineOtrasEmpresas: 0.0,
      ahorroTarjetaOro: 0.0,
      ahorroEmpresasBonificadas: 0.0,
      ahorroOtros: 0.0,
      ahorroOfertaMasiva: -0.11,
      ahorroPuntosTravel: 1.0,
      porcentSocio: 0,
      porcentOfertas: -11,
      porcentPuntosTravel: 100,
    },
    {
      mes: 202011,
      anio: 2020,
      ahorroTotal: 48.95,
      ahorroPotencialOro: 28.27,
      ahorroPertenenciaClub: 40.05,
      ahorroTarjetaEroski: 4.0,
      ahorroPertenenciaPlan: 3.4,
      ahorroOfertasSocio: 5.0,
      ahorroVales: -5.0,
      ahorroComprasOnlineOtrasEmpresas: 0.99,
      ahorroTarjetaOro: 22.22,
      ahorroEmpresasBonificadas: -1.44,
      ahorroOtros: 10.88,
      ahorroOfertaMasiva: 8.9,
      ahorroPuntosTravel: 0.0,
      porcentSocio: 82,
      porcentOfertas: 18,
      porcentPuntosTravel: 0,
    },
    {
      mes: 202010,
      anio: 2020,
      ahorroTotal: 48.95,
      ahorroPotencialOro: 28.27,
      ahorroPertenenciaClub: 40.05,
      ahorroTarjetaEroski: 4.0,
      ahorroPertenenciaPlan: 3.4,
      ahorroOfertasSocio: 5.0,
      ahorroVales: 0.99,
      ahorroComprasOnlineOtrasEmpresas: -5.0,
      ahorroTarjetaOro: -1.44,
      ahorroEmpresasBonificadas: 22.22,
      ahorroOtros: 10.88,
      ahorroOfertaMasiva: 0.0,
      ahorroPuntosTravel: 8.9,
      porcentSocio: 82,
      porcentOfertas: 0,
      porcentPuntosTravel: 18,
    },
    {
      mes: 202009,
      anio: 2020,
      ahorroTotal: 30.05,
      ahorroPotencialOro: 28.27,
      ahorroPertenenciaClub: 40.05,
      ahorroTarjetaEroski: -1.44,
      ahorroPertenenciaPlan: -5.0,
      ahorroOfertasSocio: 5.0,
      ahorroVales: 0.99,
      ahorroComprasOnlineOtrasEmpresas: 3.4,
      ahorroTarjetaOro: 4.0,
      ahorroEmpresasBonificadas: 22.22,
      ahorroOtros: 10.88,
      ahorroOfertaMasiva: -5.0,
      ahorroPuntosTravel: -5.0,
      porcentSocio: 133,
      porcentOfertas: -17,
      porcentPuntosTravel: -17,
    },
    {
      mes: 202008,
      anio: 2020,
      ahorroTotal: 250.0,
      ahorroPotencialOro: 280.0,
      ahorroPertenenciaClub: 210.0,
      ahorroTarjetaEroski: 25.0,
      ahorroPertenenciaPlan: 25.0,
      ahorroOfertasSocio: 15.0,
      ahorroVales: 15.0,
      ahorroComprasOnlineOtrasEmpresas: 15.0,
      ahorroTarjetaOro: 5.0,
      ahorroEmpresasBonificadas: 10.0,
      ahorroOtros: 100.0,
      ahorroOfertaMasiva: 15.0,
      ahorroPuntosTravel: 25.0,
      porcentSocio: 84,
      porcentOfertas: 6,
      porcentPuntosTravel: 10,
    },
    {
      mes: 202007,
      anio: 2020,
      ahorroTotal: 250.55,
      ahorroPotencialOro: 280.08,
      ahorroPertenenciaClub: 210.36,
      ahorroTarjetaEroski: 25.01,
      ahorroPertenenciaPlan: 25.02,
      ahorroOfertasSocio: 15.03,
      ahorroVales: 15.04,
      ahorroComprasOnlineOtrasEmpresas: 15.05,
      ahorroTarjetaOro: 5.06,
      ahorroEmpresasBonificadas: 10.07,
      ahorroOtros: 100.08,
      ahorroOfertaMasiva: 15.09,
      ahorroPuntosTravel: 25.1,
      porcentSocio: 84,
      porcentOfertas: 6,
      porcentPuntosTravel: 10,
    },
    {
      mes: 202006,
      anio: 2020,
      ahorroTotal: 25.09,
      ahorroPotencialOro: 21.08,
      ahorroPertenenciaClub: 21.36,
      ahorroTarjetaEroski: 2.5,
      ahorroPertenenciaPlan: 2.5,
      ahorroOfertasSocio: 1.5,
      ahorroVales: 1.5,
      ahorroComprasOnlineOtrasEmpresas: 1.5,
      ahorroTarjetaOro: 0.5,
      ahorroEmpresasBonificadas: 1.0,
      ahorroOtros: 10.08,
      ahorroOfertaMasiva: 1.5,
      ahorroPuntosTravel: 2.51,
      porcentSocio: 85,
      porcentOfertas: 6,
      porcentPuntosTravel: 10,
    },
  ];

  ahorrosPorMesList = [
    { year: 2021, month: 202104, ahorro: -8.0 },
    { year: 2021, month: 202103, ahorro: 0.0 },
    { year: 2021, month: 202102, ahorro: 5.25 },
    { year: 2021, month: 202101, ahorro: 0.0 },
    { year: 2020, month: 202012, ahorro: 1.0 },
    { year: 2020, month: 202011, ahorro: 48.95 },
    { year: 2020, month: 202010, ahorro: 48.95 },
    { year: 2020, month: 202009, ahorro: 30.05 },
    { year: 2020, month: 202008, ahorro: 250.0 },
    { year: 2020, month: 202007, ahorro: 250.55 },
    { year: 2020, month: 202006, ahorro: 25.09 },
    { year: 2020, month: 202105, ahorro: 0.0 },
  ];

  getAhorrosResponse = () => {
    const data = {
      error: false,
      pojos: this.pojos,
      pageNumber: null,
      ahorrosPorMesList: this.ahorrosPorMesList,
      saldo: '30,32',
      puntosTravel: 20000,
      ahorroPotencialOroAnual: 20,
      ahorroTotalAnual: 200,
      totalCompras: 1000,
    };
    return data;
  };

  getAhorrosResponseByDates = (periodo: number) => {
    const filteredPojo = this.pojos.find((pojo) => pojo.mes === periodo);
    const data = {
      error: false,
      pojo: filteredPojo,
    };
    return data;
  };

  private filter = (pojo: any, periodo: number) => {
    if (pojo.mes === periodo) {
      return pojo;
    }
    return null;
  };
}
